import { AlertTriangle, RefreshCw } from 'lucide-react'

import { Button, SelectField } from '@krp/ui-kit'

import '../../../shared/uc1b/journals.css'
import '../../../shared/ui/aqsi.css'
import { QueryState } from '@krp/sale-ui'
import type { DiscrepanciesActions, DiscrepanciesVm } from '../model/types'

/**
 * Журнал расхождений чеков (C4a пишет, C4b отдаёт по HTTP): чек кабинета против
 * локальной продажи или сохранённой копии. Новые первыми; строки не удаляются.
 */
export function DiscrepanciesScreen({ vm, actions }: { vm: DiscrepanciesVm; actions: DiscrepanciesActions }) {
  return (
    <section className="aqsi-journal" aria-labelledby="aqsi-discrepancies-title">
      <header className="aqsi-journal__head">
        <h2 id="aqsi-discrepancies-title">Расхождения чеков</h2>
        <Button variant="ghost" icon={<RefreshCw size={16} aria-hidden="true" />} onClick={actions.reload}>
          Обновить
        </Button>
      </header>
      <div className="aqsi-journal__filters">
        <SelectField
          label="Показать последние"
          value={String(vm.limit)}
          options={vm.limitOptions.map((limit) => ({ value: String(limit), label: String(limit) }))}
          onChange={(value) => actions.limitChanged(Number(value))}
        />
      </div>
      <QueryState query={vm.query} what="Журнал" emptyText="Расхождений нет" onRetry={actions.reload} />
      {vm.rows.length > 0 && (
        <>
          <p className="aqsi-caption">{vm.caption}</p>
          <ul className="aqsi-journal__list" aria-label="Расхождения">
            {vm.rows.map((row) => (
              <li key={row.id} className="aqsi-journal__item" data-attention="true">
                <div className="aqsi-journal__item-main">
                  <AlertTriangle size={16} aria-hidden="true" />
                  <strong>{row.kindText}</strong>
                  <span>{row.detectedText}</span>
                </div>
                <p className="aqsi-card__text">{row.detail}</p>
                <div className="aqsi-journal__meta">
                  <span>Чек: {row.receiptText}</span>
                  <span>Продажа: {row.saleText}</span>
                  <span>У нас: {row.localText}</span>
                  <span>В кабинете: {row.externalText}</span>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  )
}
